import { render } from "./ShopLogo.vue?vue&type=template&id=66c220f3&scoped=true"
import script from "./ShopLogo.vue?vue&type=script&lang=js"
export * from "./ShopLogo.vue?vue&type=script&lang=js"

import "./ShopLogo.vue?vue&type=style&index=0&id=66c220f3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c220f3"]])

export default __exports__